import { ApiError } from '../../utils/api';

export const EXISTING_PARTICIPANT_CODE = 'fitbit_collection_invitation_existing_participant';
// One Fitbit invitation per person: a second is refused while one is waiting or Fitbit is connected.
export const INVITATION_STOP_CODES = [EXISTING_PARTICIPANT_CODE, 'fitbit_collection_invitation_already_waiting',
  'fitbit_collection_invitation_already_enrolled'];

// The server explains why it did not send an invitation (ambiguous email, an invitation already
// waiting, or already enrolled). Its message names the participant.
export function existingParticipantReason(error: unknown): string | null {
  return error instanceof ApiError && INVITATION_STOP_CODES.includes(error.code || '') && error.message ? error.message : null;
}

export function invitationOutcome({ sent, unconfirmed, alreadyInStudy }: {
  sent: number; unconfirmed: number; alreadyInStudy: { email: string; reason: string }[];
}): { title: string; message: string } | null {
  if (!unconfirmed && !alreadyInStudy.length) return null;
  const parts = [`${sent} sent.`];
  if (unconfirmed) parts.push(`${unconfirmed} could not be confirmed and remain in the form to try again.`);
  for (const item of alreadyInStudy) parts.push(`${item.email}: ${item.reason}`);
  return { title: unconfirmed ? 'Some Invitations Were Not Sent' : 'Not Sent', message: parts.join(' ') };
}
